import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

import { getLanguage } from '../../frontends/ProviderSearch/context/Internationalization/helpers';
import { useLagoon } from '../../hooks/useLagoon';
import { useSuppressNiceMembers } from '../../hooks/useSuppressNiceMembers';
import { returnSuppressFlag } from '../../utils/featureSuppress';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { LinkWithTracking } from '../LinkWithTracking/LinkWithTracking';
import { Markdown } from '../Markdown';
import type { LagoonMessageRow } from '../Utils/premiumCareDisclaimer';
import { resolvePremiumCareDisclaimer } from '../Utils/premiumCareDisclaimer';
import {
  StyledMarkdown,
  disclaimerLinkStyles,
  disclaimerPDFLinkStyles,
} from './DisclaimersContainer.styled';

export const PremiumCareDisclaimer = ({
  showPremiumCareDisclaimer,
  isPDFView,
}) => {
  const locale = getLanguage().code;
  const lagoonData = (
    useLagoon('ui-messaging') as (() => LagoonMessageRow[]) | undefined
  )?.();

  const {
    content: premiumDisclaimerContent,
    linkText: premiumDisclaimerLinkText,
    url: navigationURL,
  } = resolvePremiumCareDisclaimer({
    locale,
    lagoonData,
  });

  const suppressPremiumCareDisclaimer = returnSuppressFlag(
    ConstantsLagoon.FEATURE_SUPPRESSION_FLAGS.PREMIUM_CARE
  );
  const {
    suppressForNiceMembers: suppressPremiumCareDisclaimerForNiceMembers,
  } = useSuppressNiceMembers();

  if (
    showPremiumCareDisclaimer &&
    !(
      suppressPremiumCareDisclaimer ||
      suppressPremiumCareDisclaimerForNiceMembers
    )
  ) {
    return (
      <>
        {isPDFView ? (
          <Markdown
            data-auto-testid="premium-care-disclaimer-pdf-content"
            data-testid="premium-care-disclaimer-pdf-content"
          >
            {premiumDisclaimerContent}
          </Markdown>
        ) : (
          <StyledMarkdown
            data-auto-testid="premium-care-disclaimer-content"
            data-testid="premium-care-disclaimer-content"
          >
            {premiumDisclaimerContent}
          </StyledMarkdown>
        )}
        <LinkWithTracking
          analyticsInfo={{
            location: 'body:premium care disclaimer',
            type: 'download',
          }}
          css={isPDFView ? disclaimerPDFLinkStyles : disclaimerLinkStyles}
          data-auto-testid="premium-care-disclaimer-link-text"
          data-testid="premium-care-disclaimer-link-text"
          href={navigationURL}
          openNewWindow={!isPDFView}
          size="$sm"
        >
          {premiumDisclaimerLinkText}
          <IconSymbol icon="chevron_right" size="$xs" />
        </LinkWithTracking>
      </>
    );
  }

  return null;
};
